import {
  FormHelperText,
  InputAdornment,
  Select,
  TextField,
} from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import workflowStepdotsIcon from "../../../../../styles/svg/workflowStepdotsIcon.svg";
import adminWorkflowDelete from "../../../../../styles/svg/adminWorkflowDelete.svg";

import { deleteWorkflowStep } from "../../../../../sevices/apiWorkflows";
import { useGenericWorkflowStatus } from "../../../../../utils/reactQuery/workflows";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import { RFHTextField, RHFSelect } from "../../../../../components/RFH";
import useMutate from "../../../../../hooks/useMutate";

const DraggableField = ({
  field,
  index,
  remove,
  edit,
  setOpenRemoveStep,
  setCurrentStep,
  errors,
}) => {
  const { genericWorkflowStatus } = useGenericWorkflowStatus();

  const { mutate: deleteWorkflowStepMutate } = useMutate(deleteWorkflowStep,["adminWorkflow"], 
    () => {},
      () => {
      //toast.success(res.data.message);
      remove(index);
    },
    () => {
      setOpenRemoveStep(true);
    });

  const handleDelete = useCallback((field) => {
    if (field.workflow_step_id) {
      setCurrentStep(field);

      deleteWorkflowStepMutate({ workflow_step_id: field.workflow_step_id });
    } else {
      remove(index);
    }
  }, []);

  const genericOptions = useMemo(() => {
    return genericWorkflowStatus?.data?.data?.responseData || [];
  }, [genericWorkflowStatus]);

  return (
    <>
      <Draggable key={field.id} draggableId={field.id} index={index}>
        {(provided) => (
          <div
            className="workflowStep-container"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            key={field.id}
          >
            <RFHTextField
              id={`workflow_steps.${index}.status`}
              size="small"
              // variant="standard"
              autoFocus
              defaultPadding={false}
              name={`workflow_steps.${index}.status`}
              InputProps={{
                // disableUnderline: true,
                sx: {
                  className: "workflow-input",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={workflowStepdotsIcon} alt="" />
                  </InputAdornment>
                ),
              }}
              className={"workflow-step-name"}
              error={!!errors?.workflow_steps?.[index]?.status?.message}
              helperText={errors?.workflow_steps?.[index]?.status?.message}
            />

            <RHFSelect
              name={`workflow_steps.${index}.generic_step_id`}
              SelectProps={{
                displayEmpty: true,
              }}
              className="workflow-step-select-field"
              error={!!errors?.workflow_steps?.[index]?.generic_step_id}
              helperText={
                errors?.workflow_steps?.[index]?.generic_step_id?.message
              }
            >
              <CustomMenuItem value="">
                <em>None</em>
              </CustomMenuItem>
              {genericOptions?.map((ele, idx) => (
                <CustomMenuItem
                  key={`create-workflowstep-${idx}`}
                  value={ele?.workflow_step_id}
                >
                  {ele.status}
                </CustomMenuItem>
              ))}
            </RHFSelect>

            <div
              className="workflowStep-delete"
              onClick={() => (edit ? handleDelete(field) : remove(index))}
            >
              <img src={adminWorkflowDelete} alt="" />
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
};

export default React.memo(DraggableField);
